import * as React from "react";
import { IImportedXmlDetails } from "../../../models/IImportedXml";
import { TextInput, FormDownloadButton } from "soprasteria-ui-library";
import { dateTimeToDateString } from "../../../helpers/DateHelper";
import { useAuth } from "../../../App";
import { ImportXmlApi } from "../../../api/ImportXmlApi";

interface IImportedXmlDetailsInformation {
    importedXml?: IImportedXmlDetails;
    changeErrorMessage: (message: string) => void;
}

export const ImportedXmlDetailsInformation: React.FunctionComponent<IImportedXmlDetailsInformation> = ({ importedXml, changeErrorMessage }) => {

    const auth = useAuth();
    const api = new ImportXmlApi(auth);
    const [isDownloadingFile, setIsDownloadingFile] = React.useState<boolean>(false);


    const downloadFile = () => {
        if (importedXml) {
            setIsDownloadingFile(true);
            api.getXmlFile(importedXml?.importedXmlId, () => {

            }, (errorMessage) => {
                alert(errorMessage)
            }, () => {
                setIsDownloadingFile(false);
            });
        }
    }

    return (
            <div className="row readonly-less-margin">
                <div className="col-6">
                    <FormDownloadButton name="downloadFile" label="Filnamn" text={importedXml?.fileName ?? ""} inlineLabel disabled={!importedXml?.canDownloadFile ?? true} onClick={() => downloadFile()} isLoading={isDownloadingFile} />
                </div>
                <div className="col-6">
                    <TextInput name="importedXmlTypeReadonly" label="Filtyp" defaultValue={importedXml?.importedXmlType ?? ""} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="importedXmlDateReadonly" label="Datum" defaultValue={dateTimeToDateString(importedXml?.importedDate)} inlineLabel readonly />
                </div>
                <div className="col-6">
                </div>
                <div className="col-6">
                    <TextInput name="numberOfRowsReadonly" label="Antal ärenden" defaultValue={importedXml?.numberOfRows.toString() ?? ""} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="numberOfErrorsReadonly" label="Loggade fel" defaultValue={importedXml?.numberOfRowsWithErrors.toString() ?? ""} inlineLabel readonly />
                </div>
            </div>
    );
}